<div class="import-tms-load-result">
    <div class="col-xs-3">
        <span [i18n]="'local-loads.import.tms.results.load.load-number-new'"></span>
        <a class="cmaweb-link" [href]="link.goToLoadManagementForLoad(result.loadNumber)" target="_blank">{{result.loadNumber}}</a>
    </div>
    <div class="col-xs-3">
        <span [i18n]="'local-loads.import.tms.results.load.shipment-numbers-new'"></span>
        <a class="cmaweb-link" [href]="link.goToLoadManagementForDelivery(result.shipmentNumbersString)" target="_blank">{{result.shipmentNumbersString}}</a>
    </div>
    <div class="col-xs-3" [i18n]="[{target: 'innerHTML', key: 'local-loads.import.tms.results.load.vehicle', params: { vehicle: result.vehicle }}]" *ngIf="result.vehicle"></div>
    <div class="col-xs-3" [i18n]="[{target: 'innerHTML', key: 'local-loads.import.tms.results.load.vehicle-unassigned'}]" *ngIf="!result.vehicle"></div>
    <div class="col-xs-3" *ngIf="result.errorMessage">{{ result.errorMessage }}</div>
</div>
